<template>
  <div>
    <v-mask
      v-show="toggle==1"
      style="background:none;"
      @touchmove="gtouchmove"
      @click="handleToggle(0)"
    ></v-mask>
    <div
      v-bind:class="{'hour2happy-box':true,'hour2happy-box-horizontal':!portrait,'hour2happy-box-portrait':portrait,'ani-time':toggle!=-1,'close':toggle!=1,'expand':toggle==1,'appPlatform':platform!=0}"
    >
      <div class="hour2happy">
        <span class="time">{{timeStr}}</span>
        <div class="pre-win-box">
          <div class="s-item" v-if="result.award_info.nick_name">
            <span class="s-yellow">恭喜</span>
            <span class="s-blue">{{result.award_info.nick_name}}</span>玩家获得
          </div>
          <div class="s-item" v-if="result.award_info.period_no">
            <span class="s-red">第{{result.award_info.period_no}}期</span>
            <span>的红包</span>
            <span class="s-yellow">{{result.award_info.award_amount/10000}}元</span>
          </div>
          <div class="s-item">
            <span>下一期红包为</span>
            <span class="s-yellow">{{result.next_award.award_amount}}元</span>
          </div>
        </div>
        <div class="act-rule">
          <span
            class="s-yellow s-title"
            v-bind:style="{'transform':transformScale2,'width':scaleWidth}"
          >活动规则</span>
          <span v-bind:style="{'transform':transformScale2,'width':scaleWidth}">1.每10分钟送红包依次是</span>
          <span
            class="span2"
            v-bind:style="{'transform':transformScale2,'width':scaleWidth}"
          >{{result.rule_info.small}}元</span>
          <span
            v-bind:style="{'transform':transformScale2,'width':scaleWidth}"
          >2.每日整点送{{result.rule_info.middle}}元红包</span>
          <span
            v-bind:style="{'transform':transformScale2,'width':scaleWidth}"
          >3.每日6点/18点送{{result.rule_info.big_1}}元红包</span>
          <span
            v-bind:style="{'transform':transformScale2,'width':scaleWidth}"
          >4.每日12点/24点送{{result.rule_info.big_2}}元红包</span>
          <span
            class="s-yellow s-title"
            v-bind:style="{'transform':transformScale2,'width':scaleWidth}"
          >活动参与条件</span>
          <span v-bind:style="{'transform':transformScale2,'width':scaleWidth}">1.玩家必须在线</span>
          <span v-bind:style="{'transform':transformScale2,'width':scaleWidth}">2.下次开奖与上次开奖之间有牌局产生</span>
          <span v-bind:style="{'transform':transformScale2,'width':scaleWidth}">3.玩的越多中奖概率越大</span>
        </div>
        <div class="win-record">
          <span class="s-yellow s-item s-title">今日中奖纪录</span>
          <div class="record-wrapper" ref="recordWrapper">
            <div class="record-list" v-if="result.my_award_list.length>1">
              <vue-marquee :duration="600" :interval="2000" :list="result.my_award_list"></vue-marquee>
            </div>
            <div class="record-list" v-else-if="result.my_award_list.length==1">
              <span class="s-item">
                <em>喜获第{{result.my_award_list[0].award_period}}期红包</em>
                <em class="s-yellow">{{Number(result.my_award_list[0].award_gold)/10000}}元</em>
              </span>
            </div>
            <div class="record-list" v-else>
              <span class="s-item">尚未中奖，下期可能就是您</span>
            </div>
          </div>
        </div>
      </div>
      <div class="menu" v-clickMusic @click="handleToggle(1)" v-if="toggle!=1">
        <div v-bind:class="{'btn-alarmclock':true,'sport':alarmclockSport}">
          <span class="time">
            <label v-bind:style="{'transform':transformScale}">{{timeStr}}</label>
          </span>
        </div>
      </div>
      <span v-else class="btn-close" v-clickMusic @click="handleToggle(0)"></span>
    </div>
    <div class="win-result-box" v-show="!portrait && showResult">
      <div class="win-result">
        <p class="win-user">
          <span class="s-yellow">恭喜</span>
          <span class="s-blue">{{result.award_info.nick_name}}</span>
          <span>玩家获得</span>
          <span class="s-red">第{{result.award_info.period_no}}期</span>
          <span>的红包</span>
          <span class="s-yellow">{{result.award_info.award_amount/10000}}元</span>
        </p>
      </div>
    </div>
    <div class="win-result-box-portrait" v-show="portrait && showResult">
      <div class="win-user-portrait">
        <p class="win-user">
          <span class="s-yellow">恭喜</span>
          <span class="s-blue">{{result.award_info.nick_name}}</span>
          <span>玩家获得</span>
          <span class="s-red">第{{result.award_info.period_no}}期</span>
          <span>的红包</span>
          <span class="s-yellow">{{result.award_info.award_amount/10000}}元</span>
        </p>
      </div>
    </div>
    <snow v-bind="prizeConf" :show="showPrize"></snow>
  </div>
</template>

<script>
//中奖持续显示时间
const time = 5000;
import vmask from "@/components/mask.vue";
import store from "@/store/index";
import snow from "@/components/snow.vue";
import Marquee from "./marquee.vue";
import { getLotteryInfo } from "@/api/task";
const moneyPng = [
  require("@/assets/img/hour2happy/UI_SSL_yuanbao_01.png"),
  require("@/assets/img/hour2happy/UI_SSL_yuanbao_02.png"),
  require("@/assets/img/hour2happy/UI_SSL_yuanbao_03.png"),
  require("@/assets/img/hour2happy/UI_SSL_yuanbao_04.png"),
  require("@/assets/img/hour2happy/UI_SSL_yuanbao_05.png"),
  require("@/assets/img/hour2happy/UI_SSL_yuanbao_06.png"),
  require("@/assets/img/hour2happy/UI_SSL_yuanbao_07.png"),
];
export default {
  name: "hour2happy",
  data() {
    return {
      prizeConf: {
        windPower: 0.2,
        speed: 3,
        count: 50,
        size: 15,
        images: moneyPng,
      },
      showPrize: false,
      showResult: false,
      alarmclockSport: false,
      toggle: -1,
      transformScale: "translate(-50%, -50%) scale(1)",
      transformScale2: "scale(1)",
      scaleWidth: "1.58rem",
      scaleWidth2: "1.6rem",
      scaleWidth3: "1.6rem",
      portrait: false,
      result: {
        is_win: false,
        flag: false,
        my_award_list: [], //[{"award_gold":"580000","award_period":"20191229102"}]
        next_award: {
          time_left: 0,
          award_amount: 0,
          period_no: "",
        },
        award_info: {
          nick_name: "",
          period_no: "",
          award_amount: "",
        },
        rule_info: {
          small: "",
          middle: "",
          big_1: "",
          big_2: "",
        },
      },
      timeStr: "",
      timer: null,
      reqTimer: null,
    };
  },
  components: {
    "v-mask": vmask,
    "vue-marquee": Marquee,
    snow,
  },
  computed: {
    closeAllPopUp() {
      return store.state.app.closeAllPopUp;
    },
    areaSize() {
      return store.state.app.areaSize;
    },
    screenDirection() {
      return store.state.app.screenDirection;
    },
    identity() {
      return store.state.app.appInfo.identity;
    },
    isBackground() {
      return store.state.app.isBackground;
    },
    platform() {
      return store.state.app.platform;
    },
  },
  mounted() {
    this.resetScaleSize();
    this.startTimer();
  },
  watch: {
    closeAllPopUp(val) {
      if (this.toggle == 1 && val.key != "hour2happy") {
        this.handleToggle(0);
      }
    },
    areaSize() {
      this.resetScaleSize();
    },
    screenDirection(dir) {
      if (dir == "vertical") {
        this.portrait = true;
      } else {
        this.portrait = false;
      }
    },
    isBackground(isBack) {
      if (!isBack) {
        //从后台切换到前台，从服务器上面拉取最新的时间
        this.restartTimer();
      }
    },
  },
  methods: {
    handleToggle(i) {
      this.toggle = i;
      if (i == 1) {
        store.dispatch("setCloseAllPopUp", "hour2happy");
      }
    },
    formatBit(val) {
      val = +val;
      return val > 9 ? val : "0" + val;
    },
    startTimer() {
      if (this.timer != null) {
        window.clearInterval(this.timer);
      }
      let time = this.result.next_award.time_left;
      var tempT = 0;
      this.timer = window.setInterval(() => {
        time--;
        tempT++;
        if (time == 5) {
          this.alarmclockSport = true;
        }
        if (tempT >= 5) {
          if (this.showPrize) {
            this.showPrize = false;
          }
          if (this.showResult) {
            this.showResult = false;
          }
        }
        this.timeStr = this.getTimeStr(time);
        if (time <= 0) {
          window.clearInterval(this.timer);
          this.timer = null;
          //拉取开奖信息
          this.startReqTimer();
        }
      }, 1000);
    },
    restartTimer() {
      //重新拉取最新的倒计时时间
      this.reqLotteryInfo().then((res) => {
        res = res.data;
        if (res.code == 0 && res.result && res.result.flag) {
          this.result = res.result;
          this.startTimer();
        } else {
          this.$toast("时时乐活动已结束");
          this.remove();
        }
      });
    },
    getTimeStr(time) {
      if (time >= 0) {
        let min = Math.floor(time % 3600);
        let val =
          this.formatBit(Math.floor(min / 60)) +
          ":" +
          this.formatBit(time % 60);
        return val;
      } else {
        return "00:00";
      }
    },
    startReqTimer() {
      this.alarmclockSport = false;
      if (this.reqTimer != null) {
        window.clearTimeout(this.reqTimer);
        this.reqTimer = null;
      }
      this.reqLotteryInfo().then((res) => {
         res = res.data;
        if (this.showPrize) {
          this.showPrize = false;
        }
        if (this.showResult) {
          this.showResult = false;
        }
        if (res.code == 0 && res.result && res.result.flag) {
          if (
            res.result.award_info.period_no == this.result.next_award.period_no
          ) {
            this.result = res.result;
            this.showResult = true;
            this.startTimer();
            if (res.result.is_win) {
              //如果当前用户赢，则开始掉元宝
              this.showPrize = true;
            }
            //中奖信息显示持续5秒
            window.___showPrize = window.setTimeout(() => {
              if (this.showPrize) {
                this.showPrize = false;
              }
              this.showResult = false;
              window.clearTimeout(window.___showPrize);
            }, time);
          } else {
            this.reqTimer = window.setTimeout(() => {
              this.startReqTimer();
            }, 3000);
          }
        } else {
          this.$toast("时时乐活动已结束");
          this.remove();
        }
      });
    },
    reqLotteryInfo() {
      return getLotteryInfo({
        identity: this.identity,
      });
    },
    remove() {
      if (this.reqTimer != null) {
        window.clearTimeout(this.reqTimer);
        this.reqTimer = null;
      }
      if (this.timer != null) {
        window.clearInterval(this.timer);
      }
      if (this.$el.parentNode) {
        this.$el.parentNode.removeChild(this.$el);
      }
      this.$destroy(true);
    },
    gtouchmove(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    //重置适配尺寸
    resetScaleSize() {
      const h = window.document.documentElement.getBoundingClientRect().height,
        w = window.document.documentElement.getBoundingClientRect().width;
      let _h = h;
      if (w < h) {
        _h = w;
        this.portrait = true;
      } else {
        this.portrait = false;
      }
      if (_h < 720) {
        const scale = _h / 720;
        //this.transformScale = `translate(-50%, -50%) scale(${scale*2})`;
        this.scaleWidth = `${1.58 / scale}rem`;
        this.transformScale2 = `scale(0.8)`;
        this.scaleWidth3 = `${1.6 / scale}rem`;
        this.scaleWidth2 = "2rem";
      } else {
        this.transformScale = `translate(-50%, -50%) scale(1)`;
        this.transformScale2 = `scale(1)`;
        this.scaleWidth = "1.58rem";
        this.scaleWidth2 = "1.6rem";
        this.scaleWidth3 = "1.6rem";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.s-yellow {
  color: #ffe000;
}
.s-blue {
  color: #a8fdff;
}
.s-red {
  color: #ff5a55;
}
.win-result-box {
  width: 3.645rem;
  height: 1.005rem;
  background: url(~@/assets/img/hour2happy/UI_SSL_caidai_01.png) no-repeat;
  background-size: cover;
  position: absolute;
  left: 50%;
  top: 0;
  transform: translate(-50%, -1.005rem);
  z-index: 301;
  animation: show-win-result 0.3s linear forwards;
  .win-result {
    width: 3.645rem;
    height: 1.005rem;
    position: relative;
    .win-user {
      font-size: 0.1rem;
      color: #ffffff;
      text-align: center;
      position: absolute;
      left: 50%;
      width: 100%;
      top: 0.38rem;
      transform: translateX(-50%) scale(0);
      animation: win-user 0.2s linear forwards;
      animation-delay: 0.3s;
    }
  }
}
.hour2happy-box {
  &.ani-time {
    transition-duration: 0.2s;
  }
  .hour2happy {
    width: 1.84rem;
    height: 3.01rem;
    display: block;
    background: url(~@/assets/img/hour2happy/UI_SSL_bg_01.png) no-repeat;
    background-size: cover;
    position: relative;
    user-select: none;
    -webkit-touch-callout: none;
    font-size: 0.09rem;
    .time {
      width: 0.6rem;
      height: 0.22rem;
      display: block;
      font-size: 0.12rem;
      text-align: center;
      color: #ffffff;
      line-height: 0.22rem;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 0.37rem;
    }
    .pre-win-box {
      text-align: center;
      width: 1.6rem;
      height: 0.425rem;
      display: block;
      position: absolute;
      left: 0.12rem;
      top: 0.67rem;
      font-size: 0.09rem;
      color: #ffffff;
      .s-item {
        width: 1.6rem;
        line-height: 0.12rem;
        text-align: center;
        em {
          font-style: normal;
        }
        font {
          display: inline-block;
          margin: 0 auto;
          transform-origin: 0 0;
        }
      }
    }
    .act-rule {
      width: 1.58rem;
      height: 1.3rem;
      display: block;
      color: #ffffff;
      position: absolute;
      left: 0.14rem;
      top: 1.14rem;
      overflow: hidden;
      span {
        line-height: 0.13rem;
        font-size: 0.09rem;
        transform-origin: 0 0;
        float: left;
        width: 1.58rem;
        &.span2 {
          margin-left: 0.05rem;
        }
        &.f-title {
          font-size: 0.1rem;
        }
      }
    }
    .win-record {
      width: 1.6rem;
      height: 0.4rem;
      position: absolute;
      left: 0.12rem;
      top: 2.49rem;
      overflow: hidden;
      text-align: center;
      color: #ffffff;
      .record-wrapper {
        width: 1.6rem;
        height: 0.25rem;
        overflow: hidden;
        .record-list {
          margin-top: 0.05rem;
        }
      }
      .s-item {
        width: 1.6rem;
        font-size: 0.08rem;
        text-align: center;
        line-height: 0.12rem;
        &.s-title {
          font-size: 0.09rem;
        }
        font {
          display: inline-block;
          margin: 0 auto;
          transform-origin: 0 0;
        }
        em {
          font-style: normal;
        }
      }
    }
  }
  .btn-close {
    position: absolute;
    bottom: 0.3rem;
    right: -0.2rem;
    width: 0.25rem;
    height: 0.66rem;
    display: block;
    background: url(~@/assets/img/hour2happy/UI_SSL_anniu_02.png) no-repeat;
    background-size: cover;
  }
  .menu {
    width: 0.29rem;
    height: 0.805rem;
    background: url(~@/assets/img/hour2happy/UI_SSL_anniu_01.png) no-repeat;
    background-size: cover;
    position: absolute;
    bottom: 0.3rem;
    right: -0.29rem;
    .btn-alarmclock {
      position: absolute;
      top: -0.15rem;
      left: -0.01rem;
      width: 0.3rem;
      height: 0.325rem;
      background: url(~@/assets/img/hour2happy/UI_SSL_naozhong_01.png) no-repeat;
      background-size: cover;

      &.sport {
        animation: alarm 0.1s infinite;
      }
      .time {
        color: #d50002;
        width: 0.3rem;
        height: 0.33rem;
        text-align: center;
        position: relative;
        display: block;
        label {
          position: absolute;
          left: 50%;
          top: 50%;
          display: block;
          font-weight: bold;
          font-size: 0.07rem;
        }
      }
    }
  }
}
.hour2happy-box-horizontal {
  position: fixed;
  left: 0;
  width: 1.84rem;
  height: 2.91rem;
  bottom: 0.6rem;
  z-index: 10000;
  transform: translateX(-0.04rem);
  &.appPlatform {
    bottom: 0.3rem;
  }
  &.expand {
    z-index: 10001;
  }
  &.close {
    transform: translateX(-1.84rem);
  }
}
@keyframes alarm {
  0% {
    transform: rotate(6deg);
  }
  100% {
    transform: rotate(-6deg);
  }
}
@media all and (orientation: portrait) {
  .hour2happy-box-portrait {
    position: fixed;
    top: -0.61rem;
    left: 0.8rem;
    z-index: 10000;
    transform: rotate(90deg);
    &.expand {
      z-index: 10001;
    }
    &.close {
      transform: rotate(90deg) translateX(-1.81rem);
    }
  }
  .win-result-box-portrait {
    width: 1.005rem;
    height: 3.645rem;
    background: url(~@/assets/img/hour2happy/UI_SSL_caidai_01_2.png) no-repeat;
    background-size: cover;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translate(1.005rem, -50%);
    animation: show-win-result-portrait 0.3s linear forwards;
    z-index: 301;
  }
  .win-user-portrait {
    font-size: 0.1rem;
    color: #ffffff;
    position: absolute;
    right: 0;
    width: 3.645rem;
    text-align: center;
    top: 50%;
    transform: translate(1.38rem, -50%) rotate(90deg) scale(0);
    z-index: 301;
    animation: win-user-portrait 0.2s linear forwards;
    animation-delay: 0.3s;
  }
}
@keyframes show-win-result {
  0% {
    transform: translate(-50%, -1.005rem);
  }
  100% {
    transform: translate(-50%, 0);
  }
}
@keyframes show-win-result-portrait {
  0% {
    transform: translate(1.005rem, -50%);
  }
  100% {
    transform: translate(0, -50%);
  }
}
@keyframes win-user {
  0% {
    transform: translateX(-50%) scale(0);
  }
  100% {
    transform: translateX(-50%) scale(1);
  }
}
@keyframes win-user-portrait {
  0% {
    transform: translate(1.38rem, -50%) rotate(90deg) scale(0);
  }
  100% {
    transform: translate(1.38rem, -50%) rotate(90deg) scale(1);
  }
}
</style>